<template>
  <div class="col-xs-12">
    <div class="col-xs-12 col-lg-4 grid-item p-5 p-r-10" v-for="(categoryList, index) in this.menu.categoryList" v-if="categoryList !== 'undefined' && categoryList[schema.category.is_visible] == '1'">
      <div class="col-xs-12 card">
        <div class="col-xs-12 card-title text-left p-x-15">
          <span class="pull-left">{{categoryList[schema.category.name]}}</span>
        </div>
        <div class="col-xs-12 text-left">
          <ul class="nav p-x-15">
            <li
              class="card-product c-pointer"
              v-for="productListNumber in categoryList[schema.category.product_list]"
              :key="productListNumber"
              data-toggle="modal"
              :data-target="changeToProductList(productListNumber)[schema.product.type] === 1?'#infoProductModal':'#infoPackageModal'"
              @click="openModal(productListNumber, checkDisableItem(productListNumber, categoryList[schema.category.product_id]))"
              :class="{disabled: categoryList[schema.category.is_enable] == '0'}"
              :disabled="!checkDisableItem(productListNumber, categoryList[schema.category.product_id])"
            >
              <div class="p-name">{{changeToProductList(productListNumber)[schema.product.name]}}</div>
              <div class="block-price text-15" v-for="price in getLower(productListNumber)">
                <span v-if="!isNaN(getElement(price, 2))" :class="getTempE(price, 1)">
                  <img class="icon-temp" src="/static/img/icon/hot_icon.png" v-if="getTempE(price, 1) === 'text-light-pink'">
                  <img class="icon-temp" src="/static/img/icon/cold_icon.png" v-if="getTempE(price, 1) === 'text-blue'">
                  {{getElement(price, 2)}}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clear-both"></div>
  </div>
</template>
<script>
export default {
  props: {
    menu: Object,
    schema: Object,
    showMenuIcon: Number,
    getElement: Function,
    changeToProductList: Function,
    checkDisableItem: Function,
    layout: [Number, Boolean],
    showProductIcon: [Number, Boolean],
    getLower: Function,
    openModal: Function,
    getIcon: Function,
    getTempE: Function,
    prodImgList: Object
  },
  data () {
    return {
    }
  },
  methods: {
    getMainImage (pId) {
      if (this.prodImgList[pId]) return this.prodImgList[pId].main_image.url
    }
  },
  computed: {
    showXsImg () {
      var layout = this.layout
      switch (layout) {
        case 1: return false
        case 2: return true
        case 3: return true
        case 4: return false
        default: return false
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  .p-name
    max-width: calc( 100% - 80px)
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .block-price
    position: absolute
    right: 0
    top: 10px
    width: 80px
    .text-blue
      position: absolute
      left: 0px
    .text-light-pink
      position: absolute
      right: 0px
  .icon-temp
    height: 15px
  .m-l-10
    margin-left: 10px !important
  .text-light-pink
    color: #e1456d !important
</style>
<style lang="sass">
  .btn-option
    padding: 6px 10px
    border-radius: 4px
    font-size: 14px
    font-weight: 500
    margin: 5px 10px 5px 0px
    .option-number
      background: #db4d6d
      position: absolute
      top: -7px
      right: -7px
      border-radius: 10px
      font-size: 12px
</style>

<style lang="sass" scoped>
.p-x-15
  padding-left: 15px
  padding-right: 15px
.card
  border: 1px solid #eee;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);
  background: #fff;
.card-title
  color: #e1456d;
  line-height: 40px;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 15px;
  padding-top: 5px;
.card-product
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
.clear-both
  clear: both
</style>



// WEBPACK FOOTER //
// MenuList.vue?c46e44cc